<template>
  <form @submit.prevent="filterAppeal()" action="">
    <ion-row>
      <ion-col size="12">
        <ion-list>
          <ion-item v-if="validationError" lines="none">
            <ion-label className="ion-text-wrap">
              <ion-text color="danger">
                <p v-for="error of v$.$errors" :key="error.$uid">
                  <ion-icon
                    :ios="alertCircleOutline"
                    :md="alertCircleSharp"
                    size="small"
                    style="vertical-align: middle"
                  ></ion-icon
                  >{{ error.$property }}: {{ error.$message }}
                </p></ion-text
              >
            </ion-label>
          </ion-item>

          <ion-item :class="{ 'color-danger': v$.session_id.$error }">
            <ion-label position="floating">Session</ion-label>
            <ion-select v-model="session_id" :value="session_id">
              <ion-select-option
                v-for="session of sessions"
                :key="session.id"
                :value="session.id"
              >
                {{ session.name }}
              </ion-select-option>
            </ion-select>
          </ion-item>

          <ion-item :class="{ 'color-danger': v$.appeal_type_id.$error }">
            <ion-label position="floating">Appeal Type</ion-label>
            <ion-select v-model="appeal_type_id" :value="appeal_type_id">
              <ion-select-option
                v-for="appeal_type of appealTypes"
                :key="appeal_type.id"
                :value="appeal_type.id"
              >
                {{ appeal_type.name }}
              </ion-select-option>
            </ion-select>
          </ion-item>
        </ion-list>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="6">
        <ion-button
          type="button"
          expand="full"
          color="warning"
          class="ion-margin-vertical"
          @click="resetFilters"
        >
          Reset
        </ion-button>
      </ion-col>
      <ion-col size="6">
        <ion-button type="submit" expand="full" class="ion-margin-vertical">
          Save
        </ion-button>
      </ion-col>
    </ion-row>
  </form>
</template>

<script>
import {
  IonRow,
  IonCol,
  IonList,
  IonLabel,
  IonItem,
  IonSelect,
  IonSelectOption,
  IonIcon,
  IonButton,
  IonText,
  loadingController,
  alertController,
} from "@ionic/vue";

// import { alertCircleOutline, alertCircleSharp } from "ionicons/icons";

import { integer, helpers } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";

export default {
  emits: ["closeModal"],
  components: {
    IonRow,
    IonCol,
    IonList,
    IonLabel,
    IonItem,
    IonSelect,
    IonSelectOption,
    IonIcon,
    IonButton,
    IonText,
  },
  data() {
    return {
      session_id: null,
      appeal_type_id: null,

      validationError: null,
    };
  },

  computed: {
    sessions() {
      return this.$store.getters["session/allResources"];
    },
    appealTypes() {
      return this.$store.getters["attribute/appealTypes"];
    },

    filters() {
      return this.$store.getters["appeal/filters"];
    },
  },

  setup() {
    return { v$: useVuelidate() };
  },

  validations() {
    return {
      session_id: {
        integer: helpers.withMessage("can only be integers", integer),
      },
      appeal_type_id: {
        integer: helpers.withMessage("can only be integers", integer),
      },
    };
  },

  methods: {
    setModalState(state) {
      this.modalState = state;
    },

    loader(message) {
      const loading = loadingController.create({
        message: message,
        backdropDismiss: false,
      });

      return loading;
    },

    alerter(header, message, buttons = ["close"]) {
      const alert = alertController.create({
        header: header,
        message: message,
        buttons: buttons,
      });

      return alert;
    },

    setErrorResponse(error) {
      if (error.response) {
        this.xhrError.header = error.response.data.header;
        this.xhrError.message = error.response.data.message;
      } else if (error.request) {
        this.xhrError.header = error.message || error.request;
        this.xhrError.message = "Please check your connection and try again";
      } else {
        this.xhrError.header = error.message;
        this.xhrError.message = "Something went wrong. Try again later";
      }
    },

    async filterAppeal() {
      this.v$.$touch();
      if (this.v$.$error) {
        this.validationError = true;
        return;
      }

      let data = {
        session_id: this.session_id,
        appeal_type_id: this.appeal_type_id,
      };

      const spinner = await this.loader("Saving...");
      spinner.present();

      try {
        await this.$store.dispatch("appeal/filters", data);
        spinner.dismiss();
        this.$emit("closeModal");
      } catch (error) {
        spinner.dismiss();

        this.setErrorResponse(error);

        const alertDialog = await this.alerter(
          this.xhrError.header,
          this.xhrError.message
        );

        alertDialog.present();
        this.validationError = null;
      }
    },

    async fetchSessions() {
      await this.$store.dispatch("session/allResources");
      this.session_id = this.filters.session_id;
    },

    async fetchAppealTypes() {
      await this.$store.dispatch("attribute/appealTypes");
      this.appeal_type_id = this.filters.appeal_type_id;
    },

    resetFilters() {
      this.session_id = null;
      this.appeal_type_id = null;
    },
  },

  created() {
    this.fetchSessions();
    this.fetchAppealTypes();
  },
};
</script>